import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "./components/Header";
import InputBox from "./components/InputBox";
import List from "./components/List";
import Provider from "./components/Provider/Provider";
import { lightTheme, darkTheme } from "./components/Provider/theme";

const AppContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-image: ${(props) => props.theme["img-bg"]};
  background-repeat: no-repeat;
  background-size: 100% 300px;

  @media (max-width: 600px) {
    background-image: ${(props) => props.theme["img-mobile-bg"]};
  }
`;

const Wrapper = styled.div`
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

function App() {
  const [todoList, setTodoList] = useState([]);
  const [filteredTodoList, setFilteredTodoList] = useState([]);
  const [filter, setFilter] = useState("all");
  const [isThemeDark, setIsThemeDark] = useState(true);

  useEffect(() => {
    const todos = JSON.parse(localStorage.getItem("to-do")) || [];
    setTodoList(todos);
  }, []);

  useEffect(() => {
    localStorage.setItem("to-do", JSON.stringify(todoList));
  }, [todoList]);

  useEffect(() => {
    if (filter === "all") setFilteredTodoList(todoList);
    else if (filter === "completed")
      setFilteredTodoList(todoList.filter((item) => item.isCompleted));
    else setFilteredTodoList(todoList.filter((item) => !item.isCompleted));
  }, [filter, todoList]);

  const toggleCheckBox = (id) => {
    setTodoList(
      todoList.map((task) => {
        if (task.id === id) {
          task.isCompleted = !task.isCompleted;
        }
        return task;
      })
    );
  };

  const clearAllTodos = () => {
    setTodoList((prev) => prev.filter((task) => !task.isCompleted));
  };

  const deleteTask = (id) => {
    setTodoList((prev) => prev.filter((task) => task.id !== id));
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const tasks = Array.from(todoList);
    const [reorderedTask] = tasks.splice(result.source.index, 1);
    tasks.splice(result.destination.index, 0, reorderedTask);

    setTodoList(tasks);
  };

  return (
    <Provider theme={isThemeDark ? darkTheme : lightTheme}>
      <AppContainer>
        <Wrapper>
          <Header isThemeDark={isThemeDark} setIsThemeDark={setIsThemeDark} />
          <InputBox setTodoList={setTodoList} />
          <List
            items={filteredTodoList}
            clearAllTodos={clearAllTodos}
            toggleCheckBox={toggleCheckBox}
            deleteTask={deleteTask}
            filter={filter}
            setFilter={setFilter}
            handleOnDragEnd={handleOnDragEnd}
          />
        </Wrapper>
      </AppContainer>
    </Provider>
  );
}

export default App;
